(() => {
  const selector = ".pagination";

  const pagination = (element) => {
    const prevElement = element.querySelector(".pagination-prev");
    const nextElement = element.querySelector(".pagination-next");
    const prev = element.dataset.prev;
    const next = element.dataset.next;
    const pages = element.dataset.pages;
    const page = element.dataset.page;
    const pageUrl = element.dataset.pageUrl;

    if (nextElement) nextElement.remove();

    const links = generatePagination({ pages, page, pageUrl });
    links.forEach((link) => {
      element.appendChild(link);
    });
    if (nextElement) element.appendChild(nextElement);
  };

  /**
   * Generate pagination links following the rules:
   *  - display the 2 pages before the current page
   *  - display the 2 pages after the current page
   *  - if current page + 3 < total pages, then display [...]
   *  - always display the total pages
   *
   * @param {number} pages - The total number of pages
   * @param {number} page - The current page number
   * @returns {HTMLElement[]} - An array of <a> elements to be added to the page
   */
  const generatePagination = ({ pages, page, pageUrl }) => {
    const links = [];
    const currentPage = parseInt(page, 10);
    const totalPages = parseInt(pages, 10);

    // Fonction helper pour créer un lien de pagination
    const createLink = (pageNum) => {
      const link = document.createElement(pageNum === currentPage ? "span" : "a");
      if (pageNum !== currentPage) link.href = `${pageUrl}${pageNum === 1 ? "" : "page/" + pageNum}`;
      link.textContent = pageNum;
      link.classList.add("pagination-link");
      if (pageNum === currentPage) {
        link.classList.add("pagination-current");
      }
      return link;
    };

    // Toujours afficher la première page
    links.push(createLink(1));

    // Ajouter [...] si on n'est pas proche du début
    if (currentPage - 2 > 2) {
      const ellipsis = document.createElement("span");
      ellipsis.textContent = "...";
      ellipsis.classList.add("pagination-ellipsis");
      links.push(ellipsis);
    }

    // Afficher les 2 pages avant la page courante
    for (let i = Math.max(2, currentPage - 2); i < currentPage; i++) {
      links.push(createLink(i));
    }

    // Afficher la page courante si ce n'est pas la première ou dernière page
    if (currentPage !== 1 && currentPage !== totalPages) {
      links.push(createLink(currentPage));
    }

    // Afficher les 2 pages après la page courante
    for (let i = currentPage + 1; i <= Math.min(totalPages - 1, currentPage + 2); i++) {
      links.push(createLink(i));
    }

    // Ajouter [...] si on n'est pas proche de la fin
    if (currentPage + 3 < totalPages) {
      const ellipsis = document.createElement("span");
      ellipsis.textContent = "...";
      ellipsis.classList.add("pagination-ellipsis");
      links.push(ellipsis);
    }

    // Toujours afficher la dernière page si ce n'est pas la première
    if (totalPages > 1) {
      links.push(createLink(totalPages));
    }

    return links;
  };

  [...document.querySelectorAll(selector)].forEach(pagination);
})();
